export var buttonThemes = {
  "default": {
    fill: {
      color: 'foreground',
      backgroundColor: 'grey-3',
      hover: {
        backgroundColor: 'grey-4'
      },
      active: {
        backgroundColor: 'grey-5'
      }
    },
    outline: {
      stroke: 'separatorSecondary',
      color: 'foreground',
      hover: {
        backgroundColor: 'highlight'
      },
      active: {
        backgroundColor: 'highlightSecondary'
      }
    },
    naked: {
      color: 'foreground',
      hover: {
        backgroundColor: 'highlight'
      },
      active: {
        backgroundColor: 'highlightSecondary'
      }
    }
  },
  white: {
    fill: {
      color: 'primary',
      backgroundColor: 'white',
      hover: {
        backgroundColor: 'grey-0'
      },
      active: {
        backgroundColor: 'grey-1'
      }
    },
    outline: {
      stroke: 'white',
      color: 'white',
      hover: {
        backgroundColor: 'light-0'
      },
      active: {
        backgroundColor: 'light-1'
      }
    },
    naked: {
      color: 'white',
      hover: {
        backgroundColor: 'light-0'
      },
      active: {
        backgroundColor: 'light-1'
      }
    }
  },
  light: {
    fill: {
      color: 'white',
      backgroundColor: 'light-1',
      hover: {
        backgroundColor: 'light-2'
      },
      active: {
        backgroundColor: 'light-3'
      }
    },
    outline: {
      stroke: 'light-3',
      color: 'white',
      hover: {
        backgroundColor: 'light-0'
      },
      active: {
        backgroundColor: 'light-1'
      }
    },
    naked: {
      color: 'light-9',
      hover: {
        backgroundColor: 'light-0'
      },
      active: {
        backgroundColor: 'light-1'
      }
    }
  },
  dark: {
    fill: {
      color: 'dark-9',
      backgroundColor: 'dark-0',
      hover: {
        backgroundColor: 'dark-1'
      },
      active: {
        backgroundColor: 'dark-2'
      }
    },
    outline: {
      stroke: 'dark-3',
      color: 'dark-9',
      hover: {
        backgroundColor: 'dark-0'
      },
      active: {
        backgroundColor: 'dark-1'
      }
    },
    naked: {
      color: 'dark-9',
      hover: {
        backgroundColor: 'dark-0'
      },
      active: {
        backgroundColor: 'dark-1'
      }
    }
  },
  primary: {
    fill: {
      color: 'light-9',
      backgroundColor: 'primary',
      hover: {
        backgroundColor: 'primary-dark'
      },
      active: {
        backgroundColor: 'primary-darker'
      }
    },
    outline: {
      stroke: 'primary',
      color: 'primary',
      hover: {
        backgroundColor: 'primary-lightest'
      },
      active: {
        backgroundColor: 'primary-lighter'
      }
    },
    naked: {
      color: 'primary',
      hover: {
        backgroundColor: 'primary-lightest'
      },
      active: {
        backgroundColor: 'primary-lighter'
      }
    }
  },
  warning: {
    fill: {
      color: 'dark-9',
      backgroundColor: 'yellow-5',
      hover: {
        backgroundColor: 'yellow-4'
      },
      active: {
        backgroundColor: 'yellow-3'
      }
    },
    outline: {
      stroke: 'yellow-5',
      color: 'yellow-9',
      hover: {
        backgroundColor: 'yellow-0'
      },
      active: {
        backgroundColor: 'yellow-1'
      }
    },
    naked: {
      color: 'yellow-9',
      hover: {
        backgroundColor: 'yellow-0'
      },
      active: {
        backgroundColor: 'yellow-1'
      }
    }
  },
  error: {
    fill: {
      color: 'light-9',
      backgroundColor: 'red-5',
      hover: {
        backgroundColor: 'red-4'
      },
      active: {
        backgroundColor: 'red-3'
      }
    },
    outline: {
      stroke: 'red-5',
      color: 'red-5',
      hover: {
        backgroundColor: 'red-0'
      },
      active: {
        backgroundColor: 'red-1'
      }
    },
    naked: {
      color: 'error',
      hover: {
        backgroundColor: 'red-0'
      },
      active: {
        backgroundColor: 'red-1'
      }
    }
  },
  success: {
    fill: {
      color: 'light-9',
      backgroundColor: 'green-5',
      hover: {
        backgroundColor: 'green-4'
      },
      active: {
        backgroundColor: 'green-3'
      }
    },
    outline: {
      stroke: 'green-5',
      color: 'green-5',
      hover: {
        backgroundColor: 'green-0'
      },
      active: {
        backgroundColor: 'green-1'
      }
    },
    naked: {
      color: 'green',
      hover: {
        backgroundColor: 'green-0'
      },
      active: {
        backgroundColor: 'green-1'
      }
    }
  },
  info: {
    fill: {
      color: 'light-9',
      backgroundColor: 'blue-5',
      hover: {
        backgroundColor: 'blue-4'
      },
      active: {
        backgroundColor: 'blue-3'
      }
    },
    outline: {
      stroke: 'blue-5',
      color: 'blue-5',
      hover: {
        backgroundColor: 'blue-0'
      },
      active: {
        backgroundColor: 'blue-1'
      }
    },
    naked: {
      color: 'blue-5',
      hover: {
        backgroundColor: 'blue-0'
      },
      active: {
        backgroundColor: 'blue-1'
      }
    }
  }
};